import React from "react";
// import { useNavigate } from "react-router-dom";

import { Grid, Typography } from "@mui/material";

import { GridPadding } from "../../mainStyle.js";
import Layout from "../../layout/layout.js";

function ErrorPage(props) {
	// const navigate = useNavigate();
	if (props?.noLayout) {
		return (
			<Grid item xs={12}>
				<Grid container justifyContent="space-between" sx={GridPadding}>
					<Typography component="h4" variant="h4">
						{props?.error?.title}
					</Typography>
				</Grid>
				<Grid container justifyContent="space-between" sx={GridPadding}>
					<Typography component="h6" variant="h6">
						{props?.error?.text}
					</Typography>
				</Grid>
			</Grid>
		);
	} else {
		return (
			<Layout>
				<Grid item xs={12}>
					<Grid container justifyContent="space-between" sx={GridPadding}>
						<Typography component="h4" variant="h4">
							{props?.error?.title}
						</Typography>
					</Grid>
					<Grid container justifyContent="space-between" sx={GridPadding}>
						<Typography component="h6" variant="h6">
							{props?.error?.text}
						</Typography>
					</Grid>
				</Grid>
			</Layout>
		);
	}
}

export default ErrorPage;
